import React from "react";
import { FiCalendar, FiEye, FiImage, FiPenTool } from "react-icons/fi";

const statCards = [
  {
    key: "total",
    label: "Événements au total",
    helper: "Tous statuts confondus",
    icon: FiCalendar,
    valueKey: "total",
    className:
      "from-sky-50 to-cyan-50 text-sky-700 dark:from-sky-500/10 dark:to-cyan-500/10 dark:text-sky-300",
  },
  {
    key: "active",
    label: "Publiés",
    helper: "Visibles sur cette page",
    icon: FiEye,
    valueKey: "activeOnPage",
    className:
      "from-emerald-50 to-teal-50 text-emerald-700 dark:from-emerald-500/10 dark:to-teal-500/10 dark:text-emerald-300",
  },
  {
    key: "upcoming",
    label: "À venir",
    helper: "Événements futurs",
    icon: FiCalendar,
    valueKey: "upcomingOnPage",
    className:
      "from-violet-50 to-fuchsia-50 text-violet-700 dark:from-violet-500/10 dark:to-fuchsia-500/10 dark:text-violet-300",
  },
  {
    key: "images",
    label: "Avec vignette",
    helper: "Événements illustrés",
    icon: FiImage,
    valueKey: "withImageOnPage",
    className:
      "from-amber-50 to-orange-50 text-amber-700 dark:from-amber-500/10 dark:to-orange-500/10 dark:text-amber-300",
  },
];

export default function EventsStatsGrid({ stats, loading }) {
  return (
    <section className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {statCards.map((card) => {
        const Icon = card.icon;

        return (
          <article
            key={card.key}
            className={`rounded-[1.7rem] border border-white/70 bg-gradient-to-br p-5 shadow-sm dark:border-white/10 ${card.className}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.18em] opacity-70">
                  {card.label}
                </p>

                <p className="mt-3 text-3xl font-bold">
                  {loading ? "…" : stats[card.valueKey]}
                </p>

                <p className="mt-1 text-sm font-medium opacity-70">
                  {card.helper}
                </p>
              </div>

              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/70 text-xl shadow-sm dark:bg-white/10">
                <Icon />
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}